import React from 'react'

import { RichTextComponent } from '..'
import { WebinarPanelComponent } from '../../features/WebinarSidebarFeature/components'
import { useLiveDataQuery } from '../../../global/blocs/useLiveData'

import WebinarInfoSidebarSpeakerList from './WebinarInfoSidebarSpeakerList'

import './WebinarInfoSidebarComponent.scss'

const WebinarInfoSidebarComponent = () => {
  const { data: liveData } = useLiveDataQuery()

  if (!liveData) return null

  const {
    name,
    primary_timezone_live_date__date,
    primary_timezone_live_date__time,
    description_html,
  } = liveData

  return (
    <div className="webinar-info-sidebar-component">
      <WebinarPanelComponent>
        <div className="webinar-info-header">
          <div className="webinar-info-title">{name}</div>
          <div className="webinar-date">
            {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
            {`${primary_timezone_live_date__date} • ${primary_timezone_live_date__time}`}
          </div>
        </div>

        {description_html && <RichTextComponent text={description_html} />}

        <WebinarInfoSidebarSpeakerList />
      </WebinarPanelComponent>
    </div>
  )
}

export default WebinarInfoSidebarComponent
